<template>
  <div class="carAllotWrapper">
    <div>
      <div class="awaitAllotContainer">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="awaitAllot" v-for="(item, index) in list" :key="index">
            <div class="awaitAllotTitle">
              <div class="awaitAllotDriver">
                <img :src="carImgList.useCarImg" alt="" />
                <span>{{ item.carBrand }}</span>
              </div>
              <div
                class="tabBtn"
                :class="item.useState == 1 ? 'btnColorGreen' : 'btnColorBule'"
              >
                <span>{{ item.useState == 1 ? "使用中" : "空闲" }}</span>
              </div>
              <div class="checkbox">
                <van-checkbox
                  v-model="item.checked"
                  @click="selectCheckbox(item, index)"
                ></van-checkbox>
              </div>
            </div>
            <div class="userInfo">
              <div class="userName" v-if="item.type == '1'">
                <img :src="item.icon" alt="" />
                <span>{{ item.driverName }}</span>
              </div>
              <div class="phone" v-if="item.type == '1'">
                <img src="@/assets/car/phone.png" alt="" />
                <span>{{ item.driverPhone }}</span>
              </div>
            </div>
            <!-- <div style="font-size: 16px;padding-bottom: 20px;">剩余座位：2</div> -->
          </div>
        </van-list>
      </div>
      <div class="footerBtn">
        <div>
          <van-button
            @click="cancel"
            type="default"
            size="small"
            style="width: 30%"
            >取消</van-button
          >
          <van-button
            v-if="$route.query.change == 'true'"
            :disabled="btnloading"
            type="info"
            size="small"
            @click="changeDriver"
            style="width: 70%; background-color: #4ea27c"
            >确认</van-button
          >
          <van-button
            v-else
            :disabled="btnloading"
            type="info"
            size="small"
            @click="allotCar"
            style="width: 70%; background-color: #4ea27c"
            >确认</van-button
          >
        </div>
      </div>
    </div>
    <el-dialog
      title="选择司机"
      :visible.sync="showDialog"
      width="80%"
      :before-close="handleClose"
      class="dialog"
    >
      <div>
        <!-- 单选选项 -->
        <el-radio-group v-model="carInfo.driverType">
          <div class="flexCar">
            <el-radio :label="1">默认司机</el-radio>
            <el-input
              v-model="carInfo.defaultDriver"
              placeholder="默认司机"
              disabled
            ></el-input>
          </div>
          <el-radio :label="2" style="margin-bottom: 10px">其他</el-radio>
          <div>
            <van-cell-group :border="false">
              <van-field
                v-model="carInfo.selectedDriver"
                label="司机"
                placeholder="请填写选择司机"
                @focus="selectDriver"
              >
                <template #button>
                  <div @click="selectDriver">
                    <img
                      src="@/assets/car/bottomArrows.png"
                      alt=""
                      style="width: 12px; height: 8px"
                    />
                  </div>
                </template>
              </van-field>
            </van-cell-group>

            <van-cell-group :border="false">
              <van-field
                v-model="carInfo.phoneNumber"
                label="手机号"
                placeholder="请输入手机号"
                readonly
              >
              </van-field>
            </van-cell-group>
          </div>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" @click="showDialog = false"
          >取 消</el-button
        >
        <el-button class="submitBtn" type="primary" @click="submit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <depamentDialog
      :visible.sync="depamentDialog"
      @changeQuery="changeQuery"
      :userNames="userNames"
    />
  </div>
</template>

<script>
import apis from "@/apis/car";
import "@/assets/car/icon/iconfont.css";
import depamentDialog from "./depament.vue";
// import moment from "moment";
export default {
  name: "carAllot",
  components: {
    depamentDialog,
  },
  data() {
    return {
      carImgList: {
        useCarImg: require("@/assets/car/useCar.png"),
        notUserCarIMg: require("@/assets/car/greenCar.png"),
      },
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      list: [],
      checkedItems: [],
      btnloading: false,
      allotCarDetail: [],
      showDialog: false,
      carInfo: {
        driverType: 1, // 默认选中第一个单选按钮
        defaultDriver: "", // 默认司机姓名
        selectedDriver: "", // 填写的司机姓名
        phoneNumber: "", // 司机手机号
        username: "", // 司机工号
      },
      depamentDialog: false,
      userNames: [],
      flagType: true,
      infoList: {},
    };
  },
  mounted() {
    //获取分配详情
    if (JSON.parse(localStorage.getItem("allotCarDetail"))) {
      this.allotCarDetail = JSON.parse(localStorage.getItem("allotCarDetail"));
    }
  },
  //组件销毁时，清除localStorage中的数据
  beforeDestroy() {
    localStorage.removeItem("allotCarDetail");
  },
  methods: {
    // 提交按钮
    submit() {
      this.showDialog = false;
      this.flagType = false;
      if (this.$route.query.change == "true") {
        this.changeDriverApi(this.infoList);
      } else {
        this.allotCar();
      }
    },
    // 选择搜索司机
    changeQuery(val) {
      console.log(val, "changeQuery");
      this.userNames = val;
      this.carInfo.selectedDriver = val[0].nickname;
      this.carInfo.phoneNumber = val[0].phone;
      this.carInfo.username = val[0].username;
      
    },
    // 选择司机
    selectDriver() {
      // sessionStorage.setItem("addcarInfo", JSON.stringify(this.carInfo)); // 跳转，存表单

      // this.$router.replace("/car/facility/carManage/selectDriver?type=2");
      this.depamentDialog = true;
    },
    // 关闭弹窗
    handleClose(done) {
      this.showDialog = false;
      done();
    },
    //获取司机列表
    onLoad() {
      this.queryUseCarAllot();
    },
    //获取司机列表
    queryUseCarAllot() {
      const json = {
        carState: 0,
        page: this.page,
        pageSize: this.pageSize,
        useStartTime: new Date(this.allotCarDetail[0].useSaterTime),
        useEndTime: new Date(this.allotCarDetail[0].useEndTime),
        zoneId: localStorage.getItem("cityId"),
      };
      apis.queryAllotCarListApi(json).then((res) => {
        this.totalAll = res.data.total;
        this.finished = false;
        if (this.page === 1) {
          this.list = res.data.list;
        } else {
          this.list = this.list.concat(res.data.list);
        }
        if (this.list.length < this.totalAll) {
          this.page = this.page + 1;
        } else {
          this.finished = true;
        }
        this.loading = false;

        this.list = this.list.map((item) => {
          item.checked = false;
          return item;
        });
      });
    },
    //多选框 选中
    selectCheckbox(item, itemIndex) {
      this.checkedItems = [];
      if (item.checked) {
        this.checkedItems.push(item);
      }
      this.list = this.list.map((i, index) => {
        if (item.checked) {
          if (index === itemIndex) {
            i.checked = true;
          } else {
            i.checked = false;
          }
        }
        return i;
      });
      this.checkedItems.map((obj, index) => {
        if (!obj.checked) {
          this.checkedItems.splice(index, 1);
        }
      });
    },
    //取消分配车辆
    cancel() {
      this.checkedItems = [];
      this.$router.go(-1);
    },
    // 更换司机 确认
    changeDriver() {
      
      this.userNames = []
      if (this.checkedItems.length > 0) {
        const carInfo = this.checkedItems.map((item) => {
          return {
            useState: item.useState,
            applyNumber: item.applyNumber,
            carBrand: item.carBrand,
            id: item.id,
            type: item.type,
            driverName: item.driverName,
            driverCode: item.driverCode,
          };
        });
        const info = { ...carInfo[0] };
        console.log(info,'info');
        
        if (info.useState == 1) {
          this.$dialog
            .confirm({
              message: "该司机当前时间段非空闲，您是否确认继续更换？",
              confirmButtonText: "继续变更",
              cancelButtonText: "取消变更",
            })
            .then(() => {
              if (info.type == 2 && this.flagType) {
                this.showDialog = true;
                this.carInfo.driverType = this.allotCarDetail[0].driverType && Number(this.allotCarDetail[0].driverType);
                this.carInfo.defaultDriver = info.driverName;
                this.carInfo.selectedDriver =
                  this.allotCarDetail[0].userNickname;
                this.carInfo.username = this.allotCarDetail[0].createUser;
                this.carInfo.phoneNumber = this.allotCarDetail[0].userPhone;
                this.userNames.push({
                  username: this.allotCarDetail[0].createUser,
                });
                this.infoList = info;
                return;
              }
              this.changeDriverApi(info);
            })
            .catch(() => {
              // on cancel
              console.log("取消");
            });
        } else {
          if (info.type == 2 && this.flagType) {
            this.showDialog = true;
            this.carInfo.driverType = this.allotCarDetail[0].driverType && Number(this.allotCarDetail[0].driverType);
            this.carInfo.defaultDriver = info.driverName;
            this.carInfo.selectedDriver = this.allotCarDetail[0].userNickname;
            this.carInfo.username = this.allotCarDetail[0].createUser;
            this.carInfo.phoneNumber = this.allotCarDetail[0].userPhone;
            this.userNames = this.allotCarDetail;
            this.userNames.push({
              username: this.allotCarDetail[0].createUser,
            });
            this.infoList = info;
      
      console.log(this.allotCarDetail,'this.allotCarDetail2');
            return;
          }
          this.changeDriverApi(info);
        }
      } else {
        return this.$toast("请选择待分配车辆");
      }
    },
    // 调用 接口
    changeDriverApi(info) {
      const ids = this.allotCarDetail.map((item) => item.id);
      this.btnloading = true;
      // const json = {
      //   // applyNumber: applyNumbers.toString(),
      //   // carBrand: info.carBrand,
      //   carId: info.id,
      //   ids,
      // };
      let json;
      if (info.type == 2) {
        json = {
          carId: info.id,
          ids,
          driverType: this.carInfo.driverType,
          driverCode:
            this.carInfo.driverType == 1
              ? info.driverCode
              : this.carInfo.username,
        };
      } else {
        json = {
          // applyNumber: applyNumbers.toString(),
          // carBrand: info.carBrand,
          carId: info.id,
          ids,
          driverType: info.type,
          driverCode: info.driverCode,
        };
      }
      console.log("this.allotCarDetail[0]111", this.allotCarDetail, json);
      apis
        .carAllotInfo(json)
        .then((res) => {
          if (res.code === 200) {
            this.btnloading = false;
            this.onLoad();
            this.$router.go(-1);
            this.flagType = true;
          }
        })
        .catch(() => {
          this.btnloading = false;
          this.flagType = true;
        });
    },
    //确认分配车辆
    allotCar() {
      // this.showDialog = true;
      // return;
      this.userNames = []

      if (this.checkedItems.length > 0) {
        const carInfo = this.checkedItems.map((item) => {
          return {
            useState: item.useState,
            applyNumber: item.applyNumber,
            carBrand: item.carBrand,
            id: item.id,
            type: item.type,
            driverName: item.driverName,
            driverCode: item.driverCode,
          };
        });
        const info = { ...carInfo[0] };
        
        if (info.type == 2 && this.flagType) {
          this.showDialog = true;
          console.log(this.allotCarDetail,'this.allotCarDetail');
          
          this.carInfo.defaultDriver = info.driverName;
          this.carInfo.driverType = this.allotCarDetail[0].driverType && Number(this.allotCarDetail[0].driverType);
          this.carInfo.selectedDriver = this.allotCarDetail[0].userNickname;
          this.carInfo.username = this.allotCarDetail[0].createUser;
          this.carInfo.phoneNumber = this.allotCarDetail[0].userPhone;
          this.userNames.push({
            username: this.allotCarDetail[0].createUser,
          });
          return;
        }
        // if (info.useState == 1) {
        //   this.$toast("使用中车辆不能进行分配");

        // } else {

        // }
        // const carNum = this.checkedItems.map(item => item.maxCapacity)[0];
        // const useNumbers = this.allotCarDetail.reduce((prve, item) => {
        //   return prve + Number(item.useNumber);
        // }, 0);
        // if (Number(carNum) - 1 < Number(useNumbers)) {
        //   this.onLoad();
        //   return this.$toast("当前单据人数超过核载人数，请重新分配车辆");
        // }
        const ids = this.allotCarDetail.map((item) => item.id);
        this.btnloading = true;
        let json;
        if (info.type == 2) {
          json = {
            carId: info.id,
            ids,
            driverType: this.carInfo.driverType,
            driverCode:
              this.carInfo.driverType == 1
                ? info.driverCode
                : this.carInfo.username,
          };
        } else {
          json = {
            // applyNumber: applyNumbers.toString(),
            // carBrand: info.carBrand,
            carId: info.id,
            ids,
            driverType: info.type,
            driverCode: info.driverCode,
          };
        }
        // const json = {
        //   // applyNumber: applyNumbers.toString(),
        //   // carBrand: info.carBrand,
        //   carId: info.id,
        //   ids,
        // };
        console.log("this.allotCarDetail[0]", this.allotCarDetail, json);
        apis
          .carAllotInfo(json)
          .then((res) => {
            if (res.code === 200) {
              this.btnloading = false;
              this.onLoad();
              this.$router.go(-1);
              this.flagType = true;
            }
          })
          .catch(() => {
            this.btnloading = false;
            this.flagType = true;
          });
      } else {
        return this.$toast("请选择待分配车辆");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .carAllotWrapper {
    width: 100%;
  }

  ::v-deep .van-popup {
    width: 100%;
  }

  ::v-deep .dialog {
    .el-dialog{
      width: 80% !important;
    }
  }
}

@media screen and (min-width: 600px) {
  .carAllotWrapper {
    width: 276px * $zoom;
  }

  ::v-deep .van-popup {
    width: 276px * $zoom;
    left: initial;
  }

  ::v-deep .dialog {
    .el-dialog{
      width: 246px * $zoom !important;
    }
  }
}

.carAllotWrapper {
  font-size: 16px * $zoom;
  margin: auto;

  .awaitAllotContainer {
    padding: 0 29px;
    // margin-top: 22px;
    height: 100vh;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .awaitAllot {
      background-color: #fff;
      margin-bottom: 20px;
      border-radius: 9px;
      padding: 0 26px;

      &:last-child {
        margin-bottom: 0;
      }

      &:first-child {
        margin-top: 22px;
      }

      .awaitAllotTitle {
        display: flex;
        align-items: center;
        padding-top: 5px;
        position: relative;

        ::v-deep(.van-checkbox__icon .van-icon) {
          width: 30px;
          height: 30px;
        }

        ::v-deep .van-icon-success:before {
          height: 30px;
        }

        .awaitAllotDriver {
          font-size: 36px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #282b32;
          // margin: 0 20px;
          margin-right: 20px;
          padding-top: 36px;

          img {
            width: 44px;
            height: 36px;
            margin-right: 16px;
          }
        }

        .tabBtn {
          // width: 106px;
          height: 40px;
          line-height: 40px;
          text-align: center;

          border-radius: 6px;
          padding: 0 10px;
          margin-top: 36px;
          // opacity: 0.1;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }

        .btnColorGreen {
          background-color: #edf5f2;
          color: #4ea27c;
        }

        .btnColorBule {
          background-color: #eaf1fc;
          color: #2c76e3;
        }

        .btnColorYellow {
          background-color: #fff3e8;
          color: #ff8e20;
        }

        .checkbox {
          position: absolute;
          right: 0;
          top: 20px;
        }
      }

      .userInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 53px 0;

        .userName {
          display: flex;
          align-items: center;
          font-size: 30px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #282b32;

          img {
            width: 53px;
            height: 53px;
            border-radius: 50%;
            margin-right: 16px;
          }
        }

        .phone {
          display: flex;
          align-items: center;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4ea27c;

          img {
            width: 29px;
            height: 29px;
            margin-right: 16px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .footerBtn {
      width: 100%;
    }
  }

  @media screen and (min-width: 600px) {
    .footerBtn {
      width: 276px * $zoom;
    }
  }

  .footerBtn {
    position: fixed;
    bottom: 0;
    background-color: #fff;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }

  .dialogForm {
    padding: 40px 20px 50px 20px;

    .dialogBtn {
      display: flex;
      justify-content: space-around;
      padding: 50px 20px 0 20px;

      .btn {
        font-size: 29px;
      }
    }
  }
}
.flexCar {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  // font-size: 30px;
}
::v-deep {
  .el-radio {
    margin-right: 30px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #000 !important;
  }
  .el-radio__label {
    font-size: 30px;
  }
  .el-input.is-disabled .el-input__inner{
    color: #000 !important;
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-button {
    width: 120px;
  }
  .cancelBtn {
    color: #4ea27c;
    border: 1px solid #4ea27c;
    background: none;
    width: 200px !important;
    height: 65px !important;
    border-radius: 100px;
    margin-right: 20px;
  }
  .submitBtn {
    color: #fff;
    background: #4ea27c;
    border: 1px solid #4ea27c;
    width: 200px !important;
    height: 65px !important;
    border-radius: 100px;
  }
}
</style>
